<device-config-editor>
  <div class="card h-100">
    <div class="card-header bg-white">
      <span class="fw-semibold">Configuración del dispositivo</span>
    </div>
    <div class="card-body">

      <!-- Dispositivo offline -->
      <div if={ !props.isonline } class="text-center py-4 text-muted">
        <i class="bi bi-wifi-off mb-2" style="font-size: 2rem; opacity: 0.4;"></i>
        <p class="mb-0 small">El dispositivo está desconectado.<br>La configuración no está disponible.</p>
      </div>

      <!-- Sin cargar aún -->
      <div if={ props.isonline && !state.loading && !state.loadError && !state.originalConfig } class="text-center py-4 text-muted">
        <i class="bi bi-sliders mb-2" style="font-size: 2rem; opacity: 0.4;"></i>
        <p class="mb-2 small">La configuración no se ha cargado aún.</p>
        <button class="btn btn-sm btn-outline-primary" onclick={ loadConfig }>
          <i class="bi bi-download me-1"></i>Leer del dispositivo
        </button>
      </div>

      <!-- Cargando -->
      <div if={ props.isonline && state.loading } class="text-center py-4">
        <div class="spinner-border spinner-border-sm text-primary me-2" role="status"></div>
        <span class="text-muted small">Leyendo configuración del dispositivo...</span>
      </div>

      <!-- Error de carga -->
      <div if={ props.isonline && !state.loading && state.loadError } class="text-center py-3">
        <i class="bi bi-exclamation-triangle text-warning mb-2" style="font-size: 1.5rem;"></i>
        <p class="text-muted small mb-2">{ state.loadError }</p>
        <button class="btn btn-sm btn-outline-secondary" onclick={ loadConfig }>
          <i class="bi bi-arrow-clockwise me-1"></i>Reintentar
        </button>
      </div>

      <!-- Formulario -->
      <form if={ props.isonline && !state.loading && !state.loadError && state.originalConfig } onsubmit={ handleSubmit } novalidate>

        <!-- Salidas -->
        <div class="dd-section-label">Salidas</div>
        <div class="row g-3">
          <!-- output0_pulse_ms -->
          <div class="col-sm-6">
            <label class="form-label small fw-semibold">
              Pulso Salida 0
              <span class="text-muted fw-normal">(ms)</span>
            </label>
            <input
              type="number"
              class="form-control form-control-sm { state.errors['output0_pulse_ms'] ? 'is-invalid' : '' }"
              name="output0_pulse_ms"
              min="50" max="10000" step="1"
              value={ state.formValues.output0_pulse_ms }
              oninput={ handleInput }
            />
            <div class="invalid-feedback" if={ state.errors['output0_pulse_ms'] }>{ state.errors['output0_pulse_ms'] }</div>
          </div>

          <!-- output1_pulse_ms -->
          <div class="col-sm-6">
            <label class="form-label small fw-semibold">
              Pulso Salida 1
              <span class="text-muted fw-normal">(ms)</span>
            </label>
            <input
              type="number"
              class="form-control form-control-sm { state.errors['output1_pulse_ms'] ? 'is-invalid' : '' }"
              name="output1_pulse_ms"
              min="50" max="10000" step="1"
              value={ state.formValues.output1_pulse_ms }
              oninput={ handleInput }
            />
            <div class="invalid-feedback" if={ state.errors['output1_pulse_ms'] }>{ state.errors['output1_pulse_ms'] }</div>
          </div>
        </div>

        <!-- Secuencia PULSE_SEQ -->
        <div class="dd-section-label">Secuencia PULSE_SEQ</div>
        <div class="row g-3">
          <!-- seq_first_out -->
          <div class="col-sm-6">
            <label class="form-label small fw-semibold">Primera salida</label>
            <select
              class="form-select form-select-sm"
              name="seq_first_out"
              onchange={ handleInput }
            >
              <option value="0" selected={ state.formValues.seq_first_out === 0 }>Salida 0 primero</option>
              <option value="1" selected={ state.formValues.seq_first_out === 1 }>Salida 1 primero</option>
            </select>
          </div>

          <!-- seq_pulse0_ms -->
          <div class="col-sm-6">
            <label class="form-label small fw-semibold">
              Pulso Out0
              <span class="text-muted fw-normal">(ms)</span>
            </label>
            <input
              type="number"
              class="form-control form-control-sm { state.errors['seq_pulse0_ms'] ? 'is-invalid' : '' }"
              name="seq_pulse0_ms"
              min="50" max="10000" step="1"
              value={ state.formValues.seq_pulse0_ms }
              oninput={ handleInput }
            />
            <div class="invalid-feedback" if={ state.errors['seq_pulse0_ms'] }>{ state.errors['seq_pulse0_ms'] }</div>
          </div>

          <!-- seq_pulse1_ms -->
          <div class="col-sm-6">
            <label class="form-label small fw-semibold">
              Pulso Out1
              <span class="text-muted fw-normal">(ms)</span>
            </label>
            <input
              type="number"
              class="form-control form-control-sm { state.errors['seq_pulse1_ms'] ? 'is-invalid' : '' }"
              name="seq_pulse1_ms"
              min="50" max="10000" step="1"
              value={ state.formValues.seq_pulse1_ms }
              oninput={ handleInput }
            />
            <div class="invalid-feedback" if={ state.errors['seq_pulse1_ms'] }>{ state.errors['seq_pulse1_ms'] }</div>
          </div>

          <!-- seq_wait_ms -->
          <div class="col-sm-6">
            <label class="form-label small fw-semibold">
              Espera entre pulsos
              <span class="text-muted fw-normal">(ms)</span>
            </label>
            <input
              type="number"
              class="form-control form-control-sm { state.errors['seq_wait_ms'] ? 'is-invalid' : '' }"
              name="seq_wait_ms"
              min="0" max="10000" step="1"
              value={ state.formValues.seq_wait_ms }
              oninput={ handleInput }
            />
            <div class="invalid-feedback" if={ state.errors['seq_wait_ms'] }>{ state.errors['seq_wait_ms'] }</div>
          </div>
        </div>

        <!-- Sistema -->
        <div class="dd-section-label">Sistema</div>
        <div class="row g-3">
          <!-- log_level -->
          <div class="col-sm-6">
            <label class="form-label small fw-semibold">Nivel de log</label>
            <select
              class="form-select form-select-sm"
              name="log_level"
              onchange={ handleInput }
            >
              <option value="0" selected={ state.formValues.log_level === 0 }>0 – NONE</option>
              <option value="1" selected={ state.formValues.log_level === 1 }>1 – ERROR</option>
              <option value="2" selected={ state.formValues.log_level === 2 }>2 – WARN</option>
              <option value="3" selected={ state.formValues.log_level === 3 }>3 – INFO</option>
              <option value="4" selected={ state.formValues.log_level === 4 }>4 – DEBUG</option>
              <option value="5" selected={ state.formValues.log_level === 5 }>5 – VERBOSE</option>
            </select>
          </div>
        </div>

        <!-- Feedback de rechazo por clave -->
        <div if={ state.rejectedKeys && Object.keys(state.rejectedKeys).length > 0 } class="alert alert-warning mt-3 mb-0 small">
          <strong>El dispositivo rechazó algunos valores:</strong>
          <ul class="mb-0 mt-1">
            <li each={ entry in Object.entries(state.rejectedKeys) }>
              <code>{ entry[0] }</code>: { translateRejectionReason(entry[1], entry[0]) }
            </li>
          </ul>
        </div>

        <!-- Botones -->
        <div class="d-flex gap-2 mt-3">
          <button
            type="submit"
            class="btn btn-primary btn-sm"
            disabled={ state.saving }
          >
            <span if={ state.saving } class="spinner-border spinner-border-sm me-1" role="status"></span>
            { state.saving ? 'Guardando...' : 'Guardar cambios' }
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            onclick={ loadConfig }
            disabled={ state.saving }
          >
            <i class="bi bi-arrow-clockwise me-1"></i>Recargar
          </button>
        </div>

      </form>
    </div>
  </div>

  <script>
    import { DeviceService } from '../services/api/device.service';
    import { ToastService } from '../services/toast-service';

    const CONF_LIMITS = {
      output0_pulse_ms: { min: 50, max: 10000 },
      output1_pulse_ms: { min: 50, max: 10000 },
      seq_first_out:    { min: 0,  max: 1 },
      seq_pulse0_ms:    { min: 50, max: 10000 },
      seq_pulse1_ms:    { min: 50, max: 10000 },
      seq_wait_ms:      { min: 0,  max: 10000 },
      log_level:        { min: 0,  max: 5 },
    };

    const EMPTY_FORM = {
      output0_pulse_ms: 500,
      output1_pulse_ms: 500,
      seq_first_out: 0,
      seq_pulse0_ms: 500,
      seq_pulse1_ms: 500,
      seq_wait_ms: 500,
      log_level: 3,
    };

    export default {
      state: {
        loading: false,
        saving: false,
        loadError: null,
        formValues: { ...EMPTY_FORM },
        originalConfig: null,
        rejectedKeys: null,
        errors: {},
      },

      async loadConfig() {
        if (!this.props.device || !this.props.device._id) return;
        this.update({ loading: true, loadError: null, rejectedKeys: null });
        try {
          const res = await DeviceService.getDeviceConfig(this.props.device._id);
          if (res.ok && res.config) {
            const config = res.config;
            this.update({
              loading: false,
              originalConfig: { ...config },
              formValues: { ...EMPTY_FORM, ...config },
            });
          } else {
            this.update({
              loading: false,
              loadError: res.error || res.message || 'El dispositivo no devolvió configuración',
            });
          }
        } catch (err) {
          const msg = err && err.status >= 500
            ? 'El dispositivo no respondió. Comprueba que esté conectado.'
            : (err.message || 'Error al leer la configuración');
          this.update({ loading: false, loadError: msg });
        }
      },

      handleInput(e) {
        const { name, value } = e.target;
        const intVal = parseInt(value, 10);
        this.update({
          errors: this.clearError(name),
          formValues: { ...this.state.formValues, [name]: isNaN(intVal) ? value : intVal },
        });
      },

      // Devuelve una copia de los errores sin el campo indicado, para que la
      // marca de error desaparezca apenas el usuario corrige el dato
      clearError(name) {
        if (!this.state.errors || !this.state.errors[name]) {
          return this.state.errors;
        }

        const errors = { ...this.state.errors };
        delete errors[name];
        return errors;
      },

      // Valida todos los campos del formulario contra los rangos del contrato
      // y marca en rojo cada campo fuera de rango (espejo de CONF_LIMITS)
      validateForm() {
        const errors = {};

        for (const [key, val] of Object.entries(this.state.formValues)) {
          const limits = CONF_LIMITS[key];
          if (!limits) continue;
          if (isNaN(val) || val === '' || val === null) {
            errors[key] = 'Valor requerido';
          } else if (val < limits.min || val > limits.max) {
            errors[key] = `Valor fuera de rango [${limits.min}–${limits.max}]`;
          }
        }

        this.update({ errors });

        if (Object.keys(errors).length > 0) {
          ToastService.show('Revisá los campos marcados en rojo', 'error');
          return false;
        }

        return true;
      },

      async handleSubmit(e) {
        e.preventDefault();
        if (!this.state.originalConfig) return;

        // Validación local (espejo de rangos del contrato) antes de calcular diff
        if (!this.validateForm()) {
          return;
        }

        // Calcular diff: solo las claves que cambiaron
        const diff = {};
        for (const key of Object.keys(this.state.formValues)) {
          const val = this.state.formValues[key];
          if (val !== this.state.originalConfig[key]) {
            diff[key] = val;
          }
        }

        if (Object.keys(diff).length === 0) {
          ToastService.show('No hay cambios que guardar', 'info');
          return;
        }

        this.update({ saving: true, rejectedKeys: null });
        try {
          const res = await DeviceService.updateDeviceConfig(this.props.device._id, diff);
          if (res.ok) {
            // Actualizar originalConfig con los valores aplicados
            const newOriginal = { ...this.state.originalConfig, ...(res.applied || {}) };
            this.update({ saving: false, originalConfig: newOriginal });
            ToastService.show('Configuración guardada correctamente', 'success');
          } else {
            // Aplicación parcial o fallo total
            const applied = res.applied || {};
            const rejected = res.rejected || {};
            const newOriginal = { ...this.state.originalConfig, ...applied };
            this.update({ saving: false, originalConfig: newOriginal, rejectedKeys: rejected });
            if (Object.keys(applied).length > 0) {
              ToastService.show('Configuración guardada parcialmente. Revisa los valores rechazados.', 'warning');
            } else {
              ToastService.show('El dispositivo rechazó todos los valores', 'error');
            }
          }
        } catch (err) {
          this.update({ saving: false });
          const isTimeout = err && (err.status === 504 || err.status === 502);
          const msg = isTimeout
            ? 'El dispositivo no respondió. Comprueba que esté conectado.'
            : (err.message || 'Error al guardar la configuración');
          ToastService.show(msg, 'error');
        }
      },

      translateRejectionReason(reason, key) {
        const limits = CONF_LIMITS[key];
        switch (reason) {
          case 'out_of_range':
            return limits ? `fuera de rango [${limits.min}–${limits.max}]` : 'fuera de rango';
          case 'bad_type':
            return 'tipo de dato inválido (debe ser un entero)';
          case 'unknown_key':
            return 'clave no permitida';
          default:
            return reason;
        }
      },
    };
  </script>
</device-config-editor>
